export const FormInitialValues = {
  name: "",
  number: "",
};

export const minLengthDataValidation = 3;
export const maxLengthDataValidation = 50;

// Registration Form

export const FormRegistrationInitialValues = {
  name: "",
  email: "",
  password: "",
};

export const minLengthDataNameValidation = 1;
export const maxLengthDataNameValidation = 50;
export const minLengthDataEmailValidation = 5;
export const maxLengthDataEmailValidation = 100;
export const minPasswordDataValidation = 8;
// export const maxPasswordDataValidation = 100;
